import styled from "styled-components";
import {TextField} from "@material-ui/core";
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";

export const SearchTextFieldStyled = styled(TextFieldDefault)`
   width: 500px;
   fieldset {
    border-radius: 50px;
  }
`;